import PropTypes from 'prop-types';

import {
  PaymentInfoModal,
  countryToggleConfig,
  ListingCostsShape
} from '@spotahome/ui-library';
import { Mediator } from '@spotahome/soyuz-mediator';

import ListingContent from '../ListingContent';
import { usePricingContext } from '../../context/PricingContext';
import { landlordPoliciesContainFees } from '../../utils/landlordPolicies';
import {
  OPEN_BOOKNOW_DATEPICKER_DESKTOP,
  OPEN_BOOKNOW_DATEPICKER_MOBILE
} from '../../channels';

import './ListingPaymentInfoModal.scss';

const ListingPaymentInfoModal = ({
  currencyIsoCode,
  countryCode,
  landlordPolicies = '',
  hasRentCollection = false,
  hasDepositProtection = false,
  listingCosts = null,
  deviceType = 'desktop'
}) => {
  const {
    pricingDetails: { pricing },
    downPaymentTimeInterval,
    detailedAdminFee,
    priceRange
  } = usePricingContext();

  const offer = pricing?.offer;

  const handleAddDatesClick = () => {
    const channel =
      deviceType === 'smartphone' || deviceType === 'tablet'
        ? OPEN_BOOKNOW_DATEPICKER_MOBILE
        : OPEN_BOOKNOW_DATEPICKER_DESKTOP;
    Mediator.publish(channel);
  };

  const landlordPoliciesHasFees = landlordPoliciesContainFees(landlordPolicies);
  const moveLandlordPoliciesToPricing =
    countryToggleConfig(countryCode).moveLandlordPoliciesToPricing;

  const shouldRenderLandlordPolicies =
    moveLandlordPoliciesToPricing &&
    landlordPoliciesHasFees &&
    landlordPolicies;

  return (
    <PaymentInfoModal
      pricing={{
        ...pricing,
        listingCosts: pricing?.listingCosts || listingCosts,
        offer,
        currencyIsoCode,
        isSeasonalPricing: !!priceRange?.seasonalPrice
      }}
      downPaymentTimeInterval={downPaymentTimeInterval}
      detailedAdminFee={detailedAdminFee}
      contractDurationType={pricing && pricing.contractDurationType}
      hideDepositElanLaw={countryToggleConfig(countryCode).hideDepositElanLaw}
      hasDepositProtection={hasDepositProtection}
      onAddDatesClick={handleAddDatesClick}
      renderLandlordPolicies={
        shouldRenderLandlordPolicies
          ? () => (
              <ListingContent
                className="listing-payment-info-modal__landlord-policies"
                content={landlordPolicies}
              />
            )
          : null
      }
      hasRentCollection={hasRentCollection}
    />
  );
};

ListingPaymentInfoModal.propTypes = {
  currencyIsoCode: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  landlordPolicies: PropTypes.string,
  hasRentCollection: PropTypes.string,
  hasDepositProtection: PropTypes.bool,
  listingCosts: ListingCostsShape,
  deviceType: PropTypes.oneOf(['smartphone', 'tablet', 'desktop'])
};

export default ListingPaymentInfoModal;
